export const DEFAULT_LOT_BY_TICKER = {
    SBER: 10,
    GAZP: 10,
    ROSN: 1,
    LKOH: 1,
    YNDX: 1,
    TATN: 1,
    NVTK: 1,
};
export const resolveLotSize = (ticker, explicit) => explicit ?? DEFAULT_LOT_BY_TICKER[ticker.toUpperCase()] ?? 1;
export const sharesFromLots = (qtyLots, lotSize) => qtyLots * Math.max(lotSize, 1);
export const orderNotionalFromLots = (qtyLots, lotSize, pricePerShare) => sharesFromLots(qtyLots, lotSize) * pricePerShare;
export const orderSharesQty = (order) => order.shares_qty ?? sharesFromLots(order.qty, resolveLotSize(order.ticker, order.lot_size));
export const withOrderLots = (order) => {
    const lot_size = resolveLotSize(order.ticker, order.lot_size);
    return { ...order, lot_size, shares_qty: orderSharesQty({ ...order, lot_size }) };
};
